import create from 'zustand';
import { combine } from 'zustand/middleware';

const useRenewal = create(
  combine<any, any>(
    {
      homeRenewalEntry: {},
      cuRemaining: {},
    },
    (set) => ({
      setHomeRenewalEntry: (homeRenewalEntry: any) => {
        set(() => ({ homeRenewalEntry }));
      },
      setCuRemaining: (cuRemaining: any) => {
        set(() => ({ cuRemaining }));
      },
    }),
  ),
);

export default useRenewal;
